export default {
  light: 100,
  regular: 100,
  bold: 100,
  extraBold: 100,
  ultraBold: 100
};
